import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import '../scss/multiSelect.scss';
const CustomMultiSelect = ({
  options,
  value,
  onChange,
  placeholder,
  label,
  isMulti,
  isDisabled,
  isClearable,
  classNamePrefix,
  className,
  customStyles,
  showCountOnly = true
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selectRef = useRef(null);

  const selectedValues = Array.isArray(value) ? value.map(v => v.value) : [];

  const formatOptionLabelWithCheckbox = (option) => (
    <div className={`option-label ${selectedValues.includes(option.value) ? 'selected' : ''}`}>
      <input
        type="checkbox"
        checked={selectedValues.includes(option.value)}
        className="checkbox"
        readOnly
      />
      <div className="option-text">{option.label}</div>
    </div>
  );

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Focus input when menu opens
  useEffect(() => {
    if (menuIsOpen && selectRef.current) {
      selectRef.current.focus();
    }
  }, [menuIsOpen]);

  return (
    <div
      className="custom-multi-select-wrapper"
      ref={wrapperRef}
      onClick={() => setMenuIsOpen(true)} // Open on click inside
    >
      <Select
        ref={selectRef}
        id={`select-${label.toLowerCase().replace(' ', '-')}`}
        options={options}
        value={value}
        onChange={(options, actionMeta) => {
          onChange(options);
          if (actionMeta.action !== 'remove-value') {
            setMenuIsOpen(true);
          }
        }}
        onKeyDown={(e) => {
          const inputValue = e.target.value;
          if (e.key === 'Backspace' && inputValue === '') {
            e.preventDefault(); // Prevent removal of selected items
          }
        }}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled}
        isClearable={isClearable}
        classNamePrefix={classNamePrefix || "bg-gray"}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        formatOptionLabel={formatOptionLabelWithCheckbox}
        menuIsOpen={menuIsOpen}
        styles={customStyles || {
          control: (base) => ({ ...base }),
          valueContainer: (base) => ({ ...base }),
          input: (base) => ({ ...base }),
        }}
        components={{
          ValueContainer: ({ children, ...props }) => {
            const selected = props.getValue() || [];
            const displayText = selected.length > 0 ? `${selected.length} selected` : "";
            const selectedLabels = selected.map((option) => option.label).join(', ');

            return (
              showCountOnly ? (
                <div {...props} className="value-container">
                  <span className="selected-count-text">{displayText}</span>
                  {children}
                </div>
              ): (
                <div {...props} className="value-container">
                  <div className="selected-labels-text">{selectedLabels}</div>
                  {children}
                </div>
              )
              // <div {...props} className="value-container">
              //   <span className="selected-count-text">{displayText}</span>
              //   {children}
              // </div>
            );
          },
          MultiValue: () => null,
        }}
        className={className}
      />
    </div>
  );
};

export default CustomMultiSelect;